'use strict';

const Sticky = {
    header: null,
    headerHeight: 0,
    lastScrollY: 0,
    placeholder: null,
    init: function () {
        Sticky.header = document.querySelector('.header');
        if (Sticky.header) {
            Sticky.headerHeight = Sticky.header.getBoundingClientRect().height;

            const anchors = document.querySelector('.c-anchors:not(.c-filters__list)');
            if (anchors) {
                Sticky.placeholder = document.createElement('div');
                Sticky.placeholder.style.display = 'none';
                Sticky.placeholder.style.height = `${anchors.offsetHeight}px`;
                anchors.parentNode.insertBefore(Sticky.placeholder, anchors);
                window.addEventListener('scroll', () => Sticky.handleScroll(anchors));
            }
        }
    },
    handleScroll: function (anchors) {
        const currentScrollY = window.scrollY;
        const anchorsTop = anchors.getBoundingClientRect().top;
        const placeholderTop = Sticky.placeholder.getBoundingClientRect().top;

        if (currentScrollY > Sticky.lastScrollY && anchorsTop <= Sticky.headerHeight) {
            // Scrolling down and reaching the top of .c-anchors
            anchors.classList.add('sticky');
            anchors.style.position = 'fixed';
            anchors.style.top = `${Sticky.headerHeight}px`;
            Sticky.placeholder.style.display = 'block';
        } else if (currentScrollY < Sticky.lastScrollY && placeholderTop >= Sticky.headerHeight) {
            // Scrolling up and reaching the top of the placeholder
            anchors.classList.remove('sticky');
            anchors.style.position = 'static';
            Sticky.placeholder.style.display = 'none';
        }

        Sticky.lastScrollY = currentScrollY;
    }
};

export default Sticky;